<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { TemplatePreview } from 'dashboard/components-next/template-preview';
import { PLATFORMS } from 'dashboard/services/TemplateConstants';

// channel: whatsapp → template + processed params; sms → text
const props = defineProps({
  channel: { type: String, default: 'whatsapp' },
  template: { type: Object, default: null },
  templateParams: { type: Object, default: null },
  text: { type: String, default: '' },
  contact: { type: Object, default: null },
  issues: { type: Array, default: () => [] },
});
const { t } = useI18n();

const variables = computed(
  () => props.templateParams?.processed_params?.body || {}
);
const hasContent = computed(() =>
  props.channel === 'whatsapp' ? !!props.template : !!props.text
);
</script>

<template>
  <div class="flex flex-col gap-3">
    <div class="flex items-center justify-between">
      <h4 class="text-sm font-medium text-n-slate-12">
        {{ t('WASAPI_CAMPAIGNS.PREVIEW.TITLE') }}
      </h4>
      <slot name="actions" />
    </div>
    <div
      class="p-4 rounded-xl bg-n-alpha-1 outline outline-1 outline-n-weak min-h-32"
    >
      <p v-if="!hasContent" class="text-sm text-n-slate-11">
        {{ t('WASAPI_CAMPAIGNS.PREVIEW.EMPTY') }}
      </p>
      <TemplatePreview
        v-else-if="channel === 'whatsapp'"
        :template="template"
        :variables="variables"
        :platform="PLATFORMS.WHATSAPP"
      />
      <div
        v-else
        class="max-w-sm px-3 py-2 text-sm whitespace-pre-wrap rounded-2xl rounded-bl-sm bg-n-solid-2 text-n-slate-12"
      >
        {{ text }}
      </div>
    </div>
    <p v-if="contact" class="text-xs text-n-slate-11">
      {{
        t('WASAPI_CAMPAIGNS.PREVIEW.RENDERED_FOR', {
          name: contact.name || '—',
          phone: contact.phone_number || '—',
        })
      }}
    </p>
    <ul
      v-if="issues.length"
      class="flex flex-col gap-1 p-3 text-xs rounded-lg bg-n-ruby-3 text-n-ruby-11"
    >
      <li v-for="issue in issues" :key="issue.code + issue.message">
        {{ issue.message }}
      </li>
    </ul>
  </div>
</template>
